import React, { PropTypes } from 'react'
import Strings from 'config/strings'

const JoinGameFrom = React.createClass({

  propTypes: {
    onSubmit: PropTypes.func.isRequired
  },

  getInitialState() {
    return { code: '', open: false }
  },

  render() {
    let { open, code } = this.state

    if (!open) {
      return this.renderClosed()
    }

    return (
      <form className="col join-game btn btn--huge fill-lightGray" onSubmit={ this.onSubmit }>
        <label className="hide-visually" htmlFor="game_code">
          { Strings['home.code'] }
        </label>

        <input ref="code" className="join-game__code color-black type-btn" id="game_code" maxLength="4" placeholder="CODE" value={ code } onChange={ this.onCodeChange } autoFocus />

        <input className="type-btn color-blue" disabled={ code.length < 4 } type="submit" value="Enter Game" />
      </form>
    )
  },

  renderClosed() {
    return (
      <button className="btn btn--huge fill-lightGray color-blue block-level--fill" onClick={ this.onOpenClick }>
        Join a game
      </button>
    )
  },

  onOpenClick(e) {
    e.preventDefault()
    this.setState({ open: true })
  },

  onCodeChange(e) {
    this.setState({ code: e.target.value })
  },

  onSubmit(e) {
    e.preventDefault()

    if (this.state.code.length >= 4) {
      this.props.onSubmit(this.state.code.toUpperCase())
    }
  }
})

export default JoinGameFrom



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/join-game-form.jsx
 **/